export enum PartyEntityCodes {
  Claimant = 'Claimant',
  Insured = 'Insured',
  Beneficiary = 'Beneficiary',
  IsContact = 'IsContact',
  HasContacts = 'HasContacts',
}
